module.exports = __webpack_public_path__ + "img/before.cb168c24.svg";